import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FooterComponent } from '../../../components/footer/footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { NavbarMainComponent } from '../../navbar/pages/navbar-main/navbar-main.component';
import { ScrollTopModule } from 'primeng/scrolltop';
import { BrowserService } from 'projects/shared/services/browser.service';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-nav-footer-layout',
  templateUrl: './nav-footer-layout.component.html',
  styleUrls: ['./nav-footer-layout.component.scss'],
  standalone: true,
  imports: [CommonModule, FooterComponent, RouterOutlet, NavbarMainComponent, ScrollTopModule, SkeletonModule]
})

export class NavFooterLayoutComponent {
  pathname = this._browserService.getLocation()?.pathname;
  constructor(private _browserService: BrowserService) {
  }
}
